import _ from 'lodash'
import Backbone from 'backbone'
import MarkedField from 'scoreboard/components/marked-field'
import selects from './selects'
import requiredValidator from 'scoreboard/components/validators/required-validator'

/**
 * Alternative API for working with scoreboard-select that is more consistent
 * with our other controls and based on a Backbone.View.
 */
var BackboneSelect = Backbone.View.extend({

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		selects(this.el, this.options)

		if (this.options.required) {
			this.markedField = new MarkedField({
				el: this.el,
				validator: requiredValidator
			}).render()
		}
		return this
	},

	val: function(value) {
		if (_.isUndefined(value)) {
			return this.$el.val()
		}

		this.$el.val(value)
		selects.val(this.el, value)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.markedField], 'remove')
	}

})

export default BackboneSelect

BackboneSelect.__filename__ = 'components/backbone-select.js'
